export default __webpack_public_path__ + "static/media/kedarnath2.dcf9228b.jpg";